/**
 * Copy for the Adjustment-account picker when the synced chart of accounts has
 * no expense accounts to choose from.
 *
 * The card only mounts for a CONNECTED org, so it must never say "Connect
 * QBO/Xero" (the previous copy did, which was always wrong here). It also must
 * not contradict the "Currently set" status line below it: when an adjustment
 * account is already configured, the message acknowledges that rather than
 * flatly claiming none exist. The common real cause of an empty list is simply
 * that the first sync hasn't populated the chart of accounts yet.
 */
export function adjustmentAccountEmptyHint(args: {
  isSyncing: boolean;
  hasConfiguredAccount: boolean;
}): string {
  const { isSyncing, hasConfiguredAccount } = args;
  if (isSyncing) {
    return hasConfiguredAccount
      ? 'Your chart of accounts is still syncing. The configured adjustment account will be selectable here once it finishes.'
      : 'Your chart of accounts is still syncing — expense accounts will appear here once it finishes.';
  }
  return hasConfiguredAccount
    ? 'No expense accounts are in the synced chart of accounts right now. The configured adjustment account will reappear after the next sync.'
    : 'No expense accounts found in your synced chart of accounts yet. Run a sync above to populate it.';
}
